<template>
  <v-slide-y-reverse-transition>
    <v-card class="qa-card qa-card-center shadow-md" outlined>
      <v-card-text class="qa-icons pa-2">
        <!-- <v-btn small icon text exact x-large :to="{ name: 'PDV' }" v-if="!$config.IS_PRODUCTION || $auth.isAdmin()">
          PDV
        </v-btn> -->

        <v-btn small v-ripple="false" id="qa-dashboard" exact icon text :to="{ name: 'Home' }">
          <v-icon size="25">mdi-home</v-icon>
          <v-tooltip top activator="#qa-dashboard">Dashboard</v-tooltip>
        </v-btn>

        <v-divider vertical></v-divider>

        <v-btn small v-ripple="false" id="qa-cadastro-produto" icon text :to="{ name: 'ProdutosLista' }" v-show="$auth.can('produtos:acessar')">
          <v-icon size="25">mdi-wallet-travel</v-icon>
          <v-tooltip top activator="#qa-cadastro-produto">Cadastro de Produtos</v-tooltip>
        </v-btn>

        <v-btn small v-ripple="false" id="qa-controle-produto" icon text :to="{ name: 'ControleProdutos' }" v-show="$auth.can('controle_produtos:acessar')">
          <v-icon size="25">mdi-basket-plus</v-icon>
          <v-tooltip top activator="#qa-controle-produto">Controle de Produtos</v-tooltip>
        </v-btn>
        
        <v-btn small v-ripple="false" id="qa-compra" icon text :to="{ name: 'PedidosCompraLista' }" v-show="$auth.can('pedidoscompra:acessar')">
          <v-icon size="25">mdi-cart-check</v-icon>
          <v-tooltip top activator="#qa-compra">Pedido de Compra</v-tooltip>
        </v-btn>

        <v-btn small v-ripple="false" id="qa-estoque" icon text :to="{ name: 'EstoqueLista' }" v-show="$auth.can('movimentoestoque:acessar')">
          <v-icon size="25">mdi-swap-vertical-bold</v-icon>
          <v-tooltip top activator="#qa-estoque">Movimento de Estoque</v-tooltip>
        </v-btn>
        
        <v-btn small v-ripple="false" id="qa-etiquetas" icon text :to="{ name: 'EtiquetasProdutos' }" v-show="$auth.can('etiquetas:acessar')">
          <v-icon size="25">mdi-tag</v-icon>
          <v-tooltip top activator="#qa-etiquetas">Etiquetas de Produtos</v-tooltip>
        </v-btn>
        
        <v-divider vertical></v-divider>

        <v-btn small v-ripple="false" id="qa-pedidos-venda" icon text :to="{ name: 'PedidosLista' }" v-show="$auth.can('pedidos:acessar')">
          <v-icon size="25">mdi-cart</v-icon>
          <v-tooltip top activator="#qa-pedidos-venda">Pedidos de venda</v-tooltip>
        </v-btn>
        
        <v-btn small v-ripple="false" id="qa-caixa" icon text :to="{ name: 'CaixaLista' }" v-show="$auth.can('caixa:acessar')">
          <v-icon size="25">mdi-currency-usd</v-icon>
          <v-tooltip top activator="#qa-caixa">Caixa</v-tooltip>
        </v-btn>

        <v-btn small v-ripple="false" id="qa-extratofornecedor" icon text :to="{ name: 'ExtratoFornecedor' }" v-show="$auth.can('extratofornecedor:acessar')">
          <v-icon size="25">mdi-cash-multiple</v-icon>
          <v-tooltip top activator="#qa-extratofornecedor">Extrato de Fornecedor</v-tooltip>
        </v-btn>

        <v-btn small v-ripple="false" id="qa-compartilhar" icon text v-show="$auth.can('compartilharcontas:acessar')">
          <v-icon size="25" @click="$compartilhar.abrir()">mdi-whatsapp</v-icon>
          <v-tooltip top activator="#qa-compartilhar">Compartilhar Contas</v-tooltip>
        </v-btn>


        <v-divider vertical v-show="$auth.can('configuracoes:acessar')"></v-divider>
        
        <!-- <v-btn small v-ripple="false" id="qa-configuracoes" icon text :to="{ name: 'ConfiguracoesSistema' }" v-show="$auth.can('configuracoes:acessar')">
          <v-icon size="25">mdi-cog</v-icon>
          <v-tooltip top activator="#qa-configuracoes">Configurações</v-tooltip>
        </v-btn> -->

        <v-btn small 
          v-ripple="false" 
          v-show="$auth.can('configuracoes:acessar')"
          id="qa-configuracoes" 
          icon 
          text 
          @click="$refs.dialogoConfiguracoesSistema.abrir()"
        >
          <v-icon size="25">mdi-cog</v-icon>
          <v-tooltip top activator="#qa-configuracoes">Configurações</v-tooltip>
        </v-btn>
        
      </v-card-text>
      <zCompartilharContas ref="compartilhar"></zCompartilharContas>
      <DialogoConfiguracoesSistema ref="dialogoConfiguracoesSistema"></DialogoConfiguracoesSistema>
      <CompartilharConta ref="dialogoCompartilharConta"></CompartilharConta>
    </v-card>
  </v-slide-y-reverse-transition>
</template>

<script setup>
import { ref, onMounted, onUnmounted, getCurrentInstance, computed, inject } from 'vue';
import { useGlobalStore } from '@/app/store/pinia/global';

import zCompartilharContas from '@/components/zCompartilharContas'
import ContasChavesPix from '@/pages/fornecedores/ContasChavesPix.vue'
import DialogoConfiguracoesSistema from '@/pages/sistema/configuracoes/DialogoConfiguracoesSistema.vue';
import CompartilharConta from "@/pages/contaspagar/CompartilharConta.vue";


const { proxy } = getCurrentInstance();
const $store = proxy.$store;
const $route = proxy.$route;
const globalStore = useGlobalStore();

const window_width = ref(window.innerWidth);

const compartilhar = ref(null);
const dialogoCompartilharConta = ref(null);

const $compartilhar = inject('compartilharconta');

const resize = (event) => {
  window_width.value = window.innerWidth;
};

window.addEventListener('resize', resize);

onUnmounted(() => {
  window.removeEventListener('resize', resize);
});

const isSelected = computed((route_name) => {
  return route_name === $route.name ? 'primary' : '';
});

// function compartilharContas() {
//   // compartilhar.value.abrir();
//   // lancarPrestador();

//   dialogoCompartilharConta.value.abrir();
// }

function lancarPrestador() {


  globalStore.openDrawer({
    component: ContasChavesPix,
    width: 512,
    // location: 'left'
  });

  // drawer.value = true;
}

// function isSelected(route_name) {
//   console.log($route.name);
//   return route_name === $route.name ? 'primary' : '';
// }

</script>

<style lang="scss" scoped>

.qa-icons {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;

  @media (max-width: 600px) {
    gap: 5px;
    font-size: 0.8em;
  }

  :deep(.v-btn--round) {
    border-radius: 4px;
  }
}

.qa-card {
  position: fixed; ;
  cursor: pointer;
  transition: all 0.3s;
  bottom: 10px;
  z-index: 5;
  border-radius: 10px;

  &.qa-card-right {
    right: 20px;
  }

  &.qa-card-left {
    left: 20px;
  }
  &.qa-card-center {
    left: 50%;
    transform: translate(-50%, 0);
  }
}


.shadow-md {
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
</style>
